/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type ShopEventsListOrderByItem = (typeof ShopEventsListOrderByItem)[keyof typeof ShopEventsListOrderByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShopEventsListOrderByItem = {
  '-created_at': '-created_at',
  '-ended_at': '-ended_at',
  '-id': '-id',
  '-name': '-name',
  '-started_at': '-started_at',
  created_at: 'created_at',
  ended_at: 'ended_at',
  id: 'id',
  name: 'name',
  started_at: 'started_at'
} as const
